import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiArrowGoBackLine } from "react-icons/ri";
import './ArrowLink.scss'; // Assurez-vous que ce fichier contient le style SASS que nous avons discuté

const ArrowLink = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Redirige vers la nouvelle page lorsque l'icône est cliquée
    navigate('/Details'); // Remplacez par le chemin réel de votre nouvelle page
  };

  return (
    <div className="arrow-link" onClick={handleClick}>
      <RiArrowGoBackLine className="arrow-icon"/>
      <div className="text-container">
        <span className="text">Place an order</span>
      </div>
      <div></div> {/* Élément vide pour équilibrer la flexbox */}
    </div>
  );
};

export default ArrowLink;
